import { Modal, Button, Typography, Segmented, ConfigProvider } from 'antd';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as SubscribeIllustration } from '../../../assets/Subscribe-illustration.svg';
import { ReactComponent as BeeboltBanner } from '../../../assets/beebolt-banner-icon.svg';
import { ReactComponent as SubscribeBoltIcon } from '../../../assets/icons/subscribe-bolt-icon.svg';
import './subscribe-modal.scss';

interface ISubscribeModalProps {
  isOpen: boolean;
}

const SubscribeModal: FC<ISubscribeModalProps> = ({ isOpen }) => {
  const [plan, setPlan] = useState<'Monthly' | 'Yearly'>('Monthly');
  const navigate = useNavigate();

  return (
    <Modal
      open={isOpen}
      footer={null}
      centered
      width={1090}
      className="subscribe-modal"
      closable={false}
    >
      <div className="subscribe-modal-content">
        <div className="subscribe-modal-left">
          <div className="left-content">
            <BeeboltBanner className="beebolt-banner-wrapper" />
            <Typography.Title className="title" level={2}>
              Subscribe to OS lite
            </Typography.Title>
            <Typography.Paragraph className="content-text">
              Our entry-level plan gives you full access to all features,
              including live tracking for up to 20 shipments per month on a
              flexible monthly subscription.
            </Typography.Paragraph>

            <ConfigProvider
              theme={{
                components: {
                  Segmented: {
                    itemSelectedBg: '#E3FF2D',
                  },
                },
              }}
            >
              <Segmented
                size="large"
                block
                options={['Monthly', 'Yearly']}
                value={plan}
                onChange={(val) => setPlan(val as 'Monthly' | 'Yearly')}
                className="plan-toggle"
              />

              {plan === 'Monthly' ? (
                <Typography.Title level={1} className="price-text">
                  $199 <div className="price-text-secondary">per month</div>
                </Typography.Title>
              ) : (
                <Typography.Title level={1} className="price-text">
                  $2250 <div className="price-text-secondary">per year</div>
                </Typography.Title>
              )}
              <Typography.Text type="secondary" className="footer-text">
                One subscription, many actions
              </Typography.Text>

              <Button
                size="large"
                type="primary"
                className="subscribe-button"
                icon={<SubscribeBoltIcon />}
                data-chameleon="create-shipment-cta"
                onClick={() => navigate('/pricing')}
              >
                Subscribe
              </Button>
            </ConfigProvider>
          </div>
        </div>

        <div className="subscribe-modal-right">
          <SubscribeIllustration />
        </div>
      </div>
    </Modal>
  );
};

export default SubscribeModal;
